import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import { AiOutlineDelete, AiOutlineEye } from "react-icons/ai";
import { DataGrid } from "@mui/x-data-grid";
import { deleteShopProduct } from "../../features/shop/shopSlice";
import { toast } from "react-toastify";
import { FiPackage } from "react-icons/fi";
import Loader from "../Layout/Loader";
import SmallLoader from "../Layout/SmallLoader";
import { selectError } from "../../features/product/productSlice";
import { numbersWithCommas } from "../../utils/priceDisplay";
import { MdEdit } from "react-icons/md";

const AllProducts = ({
  handleProductClick,
  shopProducts,
  isLoading,
  handleProductEdit,
}) => {
  const deleteError = useSelector(selectError);
  const [showLoader, setShowLoader] = useState({});

  const dispatch = useDispatch();

  const handleDelete = async (id) => {
    setShowLoader((prevStates) => ({ ...prevStates, [id]: true }));
    try {
      await dispatch(deleteShopProduct(id));
    } catch (error) {
      toast.error(deleteError);
    } finally {
      setShowLoader((prevStates) => ({ ...prevStates, [id]: false }));
    }
  };

  const columns = [
    {
      field: "id",
      headerName: "Product Id",
      minWidth: 130,
      flex: 0.7,
      sortable: false,
    },
    {
      field: "name",
      headerName: "Product Name",
      minWidth: 130,
      flex: 1.0,
      sortable: false,
    },
    {
      field: "price",
      headerName: "Price",
      minWidth: 90,
      flex: 0.6,
      sortable: false,
    },
    {
      field: "stock",
      headerName: "Stock",
      minWidth: 80,
      flex: 0.6,
      sortable: false,
    },
    {
      field: "sold",
      headerName: "Sold-Out",
      minWidth: 80,
      flex: 0.6,
      sortable: false,
    },
    {
      field: "Preview",
      flex: 0.4,
      minWidth: 80,
      headerName: "",
      type: "number",
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Button onClick={() => handleProductClick(params.row.id)}>
              <AiOutlineEye size={18} />
            </Button>
          </>
        );
      },
    },
    {
      field: "Edit",
      flex: 0.4,
      minWidth: 80,
      headerName: "",
      type: "number",
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Button onClick={() => handleProductEdit(params.row.id)}>
              <MdEdit size={18} />
            </Button>
          </>
        );
      },
    },
    {
      field: "Delete",
      flex: 0.4,
      minWidth: 80,
      headerName: "",
      type: "number",
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Button onClick={() => handleDelete(params.id)}>
              {showLoader[params.id] ? (
                <SmallLoader />
              ) : (
                <AiOutlineDelete size={18} />
              )}
            </Button>
          </>
        );
      },
    },
  ];

  const rows = [];

  shopProducts &&
    shopProducts.forEach((item) => {
      rows.push({
        id: item._id,
        name: item.name,
        price: "\u20A6" + numbersWithCommas(item?.discountPrice),
        stock: item.stock,
        sold: item.sold_out,
      });
    });

  return (
    <div className="h-full pb-10">
      <div className="flex items-center justify-center sticky h-[35px] mb-3">
        <h1 className=" flex font-medium 800px:text-[22px] 800px:font-[600] text-black py-3">
          <FiPackage size={24} /> Your Shop Products
        </h1>
      </div>
      {isLoading ? (
        <div className="flex items-center justify-center  h-[60vh] ">
          <Loader />
        </div>
      ) : (
        <DataGrid
          rows={rows}
          columns={columns}
          disableRowSelectionOnClick
          autoPageSize
          disableColumnMenu
        />
      )}
    </div>
  );
};

export default AllProducts;
